module.exports = __webpack_public_path__ + "img/advisory_select_type1_01.516fceaa.png";